const rootUrl = process.env.REACT_APP_API

export function queryYourMove(params) {
  const url = `${rootUrl}/yourmove`
  return fetch(url, {
    method: 'post',
    headers: {
      Accept: 'application/json, text/plain, */*',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(params),
  })
}
